export default "__VITE_ASSET__DT3jwyQZ__"